import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import HelpLink from 'packages/kakapo-ui-kit/components/intercom/HelpLink';

import SettingsCollection from '../generic/SettingsCollection';

export default function CycleTemplatesListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useCycleTemplatesQuery as any}
			lazyQuery={graphql.useCycleTemplatesLazyQuery as any}
			field="cycleTemplates"
			translationKey="settings.cycleTemplates"
			title={(cycle: graphql.CycleTemplate) => localize(cycle.title).text}
			subheader={<HelpLink id="help.settings.cycles" />}
			link={(cycle) => `/settings/cycle-templates/${cycle.id}`}
			variables={{}}
			archive={graphql.useArchiveCycleTemplateMutation() as any}
			restore={graphql.useRestoreCycleTemplateMutation() as any}
			onAdd={() => history.push('/settings/cycle-templates/create')}
		/>
	);
}
